export var ItemTypes = {
    File: 'DND.FilePreview',
    Image: 'DND.ImagePreview',
};
